import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import { dateFormat } from "./assets/js/formData";
import "./useantd";
Vue.config.productionTip = false;
import * as filters from "@/assets/js/formData"; //全局的filter函数 也可单独引入某个模块
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
import DragModal from "@/components/globalModal"; //全局可拖拽的弹窗
Vue.component("DragModal", DragModal);

import Normap from "@/components/normap"; //表格文字提示框
Vue.component("Normap", Normap);

import Tooltip from "@/components/tooltip"; //表格文字提示框
Vue.component("Tooltip", Tooltip);

import pickTime from "@/components/pickTime"; // 因不满意ant自带时间区间选择器 无奈自定义的 时间选择器
Vue.component("timePick", pickTime);
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
});
import * as echarts from "echarts";
import common from "./assets/js/main"; //公共方法

Vue.use(common);
let watermarkInterval; // 声明一个变量来保存定时器
// const fiveMinutes = 2 * 1000;
const fiveMinutes = 5 * 50 * 1000;
function startWatermarkCheck() {
  // 先清除之前的定时器（避免重复创建）
  if (watermarkInterval) {
    clearInterval(watermarkInterval);
  }
  // 设置定时检查水印
  watermarkInterval = setInterval(() => {
    // const timeStr = localStorage.getItem("times");
    // const timestamp1 = new Date(timeStr).getTime();
    // const timestamp2 = new Date(new Date()).getTime();
    // const difference = Math.abs(timestamp1 - timestamp2);
    // const fiveMinutes = 1 * 1000;
    // console.log(difference, timestamp1, timestamp2);
    // const fiveMinutes = 5 * 50 * 1000;
    if (store.state.user.uname) {
      store.dispatch("updateWatermarks");
    }
  }, fiveMinutes);
}

// 初始化时立即启动一次
startWatermarkCheck();

// 监听页面可见性变化
document.addEventListener("visibilitychange", function () {
  if (!document.hidden) {
    // 当用户切换回标签页时，重新启动定时器
    // store.dispatch("updateWatermarks");
    startWatermarkCheck();
  }
});
// const fiveMinutes = 2 * 100;
// // const fiveMinutes = 5 * 60 * 1000; // 5分钟的毫秒数
// setInterval(() => {
//   const timeStr = localStorage.getItem("times");
//   const timestamp1 = new Date(timeStr).getTime();
//   const timestamp2 = new Date(dateFormat(new Date())).getTime();
//   // 计算时间差（毫秒）
//   const difference = Math.abs(timestamp1 - timestamp2);
//   // 5分钟对应的毫秒数：5 * 60 * 1000 = 300000
//   const fiveMinutes = 2 * 100;
//   //  const fiveMinutes = 5 * 50 * 1000;
//   // 如果相差等于5分钟返回false，否则返回true
//   if (difference > fiveMinutes) {
//     if (store.state.user.uname) {
//       store.dispatch("updateWatermarks"); // 调用 Vuex action 重新计算水印
//     }
//   }
// }, fiveMinutes);
// document.addEventListener("visibilitychange", function () {
//   if (!document.hidden) {

//   }
// });
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
